import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskKindEnum } from '@zaoblako/shared/modules/task/enum/task-kind.enum';
import { TaskKindEnumI18n } from '@zaoblako/shared/modules/task/i18n/task-kind-enum.i18n';

@Pipe({
  name: 'taskKindName',
  standalone: true
})
export class TaskKindNamePipe implements PipeTransform {
  public transform(kind: TaskKindEnum): string {
    return TaskKindEnumI18n[I18nLocalesEnum.RU_RU][kind] || '';
  }
}
